export default __webpack_public_path__ + "static/hero-38e9d82c138cc7c31a89f8ada207ed54.png";